import { useCallback } from "react";
import { useUpdateAppointment } from "@/domains/appointment/appointments/shared/hooks/useUpdateAppointment";
import type { AppointmentOutcome } from "@/gql/graphql";

/**
 * Hook for worker-specific appointment actions - simplified for worker needs
 */
export const useWorkerActions = () => {
  const { updateAppointment } = useUpdateAppointment();

  // Start service (mark as in progress)
  const startService = useCallback(
    async (appointmentId: string) => {
      return updateAppointment(appointmentId, { outcome: "IN_PROGRESS" });
    },
    [updateAppointment]
  );

  // Complete service
  const completeService = useCallback(
    async (appointmentId: string) => {
      return updateAppointment(appointmentId, { outcome: "COMPLETED" });
    },
    [updateAppointment]
  );

  // Mark as no-show
  const markNoShow = useCallback(
    async (appointmentId: string) => {
      return updateAppointment(appointmentId, { outcome: "NO_SHOW" });
    },
    [updateAppointment]
  );

  // Generic outcome update
  const updateOutcome = useCallback(
    async (appointmentId: string, outcome: AppointmentOutcome) => {
      return updateAppointment(appointmentId, { outcome });
    },
    [updateAppointment]
  );

  return {
    startService,
    completeService,
    markNoShow,
    updateOutcome,
  };
};
